import type { Hex, MiningChallengeWire } from "./types";

/** Constants independently reproduced with viem and PyCryptodome Keccak. */
export const POW_V1_VECTOR_CHALLENGE: MiningChallengeWire = {
  algorithm: "KECCAK256_ABI_V1",
  protocolVersion: 1,
  instanceId: `0x${"11".repeat(32)}` as Hex,
  chainId: "4663",
  tokenAddress: "0x2222222222222222222222222222222222222222",
  walletAddress: "0x3333333333333333333333333333333333333333",
  challengeId: `0x${"44".repeat(32)}` as Hex,
  seed: `0x${"55".repeat(32)}` as Hex,
  difficultyEpochId: "7",
  targetExclusive: "1766847064778384329583297500742918515827483896875618958121606201292619776",
  issuedAt: "1700000000",
  expiresAt: "1700043200",
  challengeCommitment: "0x8b01792753f1567d307f302a9f1426941271c57440d63758fd5e38bff451ad3b",
  status: "ACTIVE",
};

export const POW_V1_EXPECTED_DOMAIN = "0xb0716d7140889f5f5f8dfc18e214243a1d3f0d49a6a7d8d89c0523385044cfd4" as Hex;
export const POW_V1_EXPECTED_PAYLOAD_42 = (POW_V1_VECTOR_CHALLENGE.challengeCommitment +
  "000000000000000000000000000000000000000000000000000000000000002a") as Hex;
export const POW_V1_EXPECTED_DIGEST_42 = "0xd45838b04fe949018b743263a703c4c0df87eb3d949f16861cf6dc6cada0c655" as Hex;

export const POW_V1_HOT_LOOP_VECTORS: readonly { nonce: string; digest: Hex }[] = [
  { nonce: "0", digest: "0xca694ba08f78a8a5cd03e7e8ba30b0e10b4188993952926670a0de04d29671ab" },
  { nonce: "42", digest: POW_V1_EXPECTED_DIGEST_42 },
  {
    nonce: "57896044618658097711785492504343953926634992332820282019728792003956581729028",
    digest: "0xebf30e9cdd9def0996f56119fed18cecebb60b22b61925c9dae17b2e84fa3ccd",
  },
  {
    nonce: "115792089237316195423570985008687907853269984665640564039457584007913129639935",
    digest: "0x57f1d45757b60a460a040afcc4ecf48b9ee2ebc98b08b97c7e2e8a50e471741f",
  },
] as const;
